import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatRefresh(
  options?: UseMutationOptions<AxiosResponse<string>, unknown, number>
) {
  const api = useChatApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((expiration) => api.refreshToken(expiration), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries(["chat-conversations"]);
      await queryClient.invalidateQueries(["chat-auth-user"]);
    },
    ...rest,
  });
}
